// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pay[data-v-073ea493]{\n  width: 100%;\n  height:100vh;\n  background: #00C291;\n  text-align: center;\n  box-sizing: border-box;\n  color:#fff;\n  padding-top: 1.06667rem;\n}\n", ""]);
// Exports
module.exports = exports;
